import Vue from "vue";
import "./plugins/axios";
import VueURLPlugin from "./plugins/vueurl";
import filters from "./plugins/filters";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";
import i18n from "./i18n";
import router from "./router";
import TTButton from "./components/common/TTButton";
import UserBox from "./components/common/UserBox";
import ValueEditor from "./components/inputs/ValueEditor.vue"
import VuetifyConfirm from "vuetify-confirm";
import VueLogger from "vuejs-logger";
import IoTHub from "./plugins/signalr";
import UsersHub from "./plugins/signalrUser"

const vueloggeroptions = {
  isEnabled: true,
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true,
};

"#if TARGET === 'development'"
Vue.prototype.$TARGET = "development";
vueloggeroptions["logLevel"] = "debug";
"#else"
Vue.prototype.$TARGET = "production";
vueloggeroptions["logLevel"] = "fatal";
"#endif"

Vue.use(VueLogger, vueloggeroptions);

Vue.config.productionTip = false;

Vue.use(VueURLPlugin);
Vue.use(VuetifyConfirm, { vuetify });
Vue.use(IoTHub);
Vue.use(UsersHub);

for (let filter of filters) {
  Vue.filter(filter.name, filter.fun);
}

Vue.component("tt-button", TTButton);
Vue.component("userbox", UserBox);
Vue.component("value-editor", ValueEditor);

router.beforeEach(async (to, from, next) => {
  Vue.$log.debug("beforeEach: user: ", store.state.user);
  Vue.$log.debug("beforeEach: getLoggedIn: " + store.getters.getLoggedIn);
  Vue.$log.debug("beforeEach: to: ", to);
  
  if (to.name !== "login" && !store.getters.getLoggedIn) {
    Vue.$log.debug("user not found, looking for openid cookie");
    try {
      let user = await Vue.axios.get(Vue.$url("login/check"), { withCredentials: true });
      store.commit("mLogin", user.data);
    }
    catch(error) {
      Vue.$log.debug(error)
      router.push({ name: "login" })
    }
    if (to.name !== "login" && !store.getters.getLoggedIn) {
      router.push({ name: "login" });
    } else {
      Vue.$log.debug("found openid cookie, pushing to on router");
      store.commit("mShowLongLoader", i18n.te("common.pleasewait") ? i18n.t("common.pleasewait") : "Loading...");
      Vue.$log.debug(i18n.locale)
      if (i18n.locale != "en") {
        let lang = store.getters.getLoggedInUser.lang
        Vue.$log.debug("loggedInUser lang: " + lang)
        await loadTranslations(lang);
      }
      await loadBaseData();
      store.commit("mHideLongLoader");
      if (!store.state.iotSignalR.isConnected)
        Vue.$startIoTSignalR();
      if (!store.state.userSignalR.isConnected)
        Vue.$startUsersSignalR();
      next();
    }
  }
  else {
    store.commit("mShowLongLoader", i18n.t("common.pleasewait"));
    if (!store.state.baseDataLoaded) {
      await loadBaseData();
    }
    store.commit("mHideLongLoader");
    next();
  }
});

router.afterEach(async (to, from) => {
  Vue.$log.debug("afterEach: to: ", to);
  Vue.$log.debug("afterEach: from: ", from);
  if (to.name == "login" && from != undefined) {
    await loadLoginTranslations()
  }
  store.commit("mHideLongLoader");
});

Vue.mixin({
  methods: {
    dateMixin: function(date) {
      if (date == null) return "";
      return i18n.d(new Date(date), "short");
    },
    longDateMixin: function(date) {
      if (date == null) return "";
      return i18n.d(new Date(date), "long");
    },
  },
});

var tonegen = new Vue({
  vuetify,
  store,
  i18n,
  router,
  watch: {
    '$store.state.user': {
      deep: true,
      async handler(newval, oldval) {
        Vue.$log.debug("User update: ", this.$store.state.user)
        if (oldval != undefined && newval != undefined) {
          await loadTranslations(this.$store.state.user.lang)
        }
      }
    } 
  },
  render: (h) => h(App),
}).$mount("#app");

async function loadTranslations(lang) {
  var res = await Vue.axios.get(Vue.$url("i18n/" + lang));
  Vue.$log.debug("adding translations: ", res.data);
  i18n.setLocaleMessage(lang, res.data);
  i18n.locale = lang;
  Vue.axios.defaults.headers.common["Accept-Language"] = lang;
  document.querySelector("html").setAttribute("lang", lang);
  tonegen.$store.commit("mFinishedLoading");
}

async function loadBaseData() {
  await Promise.all([
    store.dispatch("doLoadDevices"),
    store.dispatch("doLoadLanguageList"),
    store.dispatch("doLoadAzureMapKey"),
    store.dispatch("doLoadKpi"),
  ])
  store.state.baseDataLoaded = true;
}

async function loadLoginTranslations() {
  let lang = "en";
  var res = await Vue.axios.get(Vue.$url("i18n"));
  Vue.$log.debug("adding login translations: ", res.data);
  i18n.setLocaleMessage(lang, res.data);
  i18n.locale = lang;
  document.querySelector("html").setAttribute("lang", lang);
  Vue.$log.info("created app: ", tonegen);
  tonegen.$store.commit("mFinishedLoading");
}
loadLoginTranslations();

export default tonegen;
